import styled from '@emotion/styled';
import { useState } from 'react';
import { IconButton } from '../icon-button';

export type PasswordProps = {
  value: string;
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const PasswordField = styled.input`
  border: none;
  background-color: transparent;
`;

export function Password({ value }: PasswordProps): JSX.Element {
  const [showPassword, setShowPassword] = useState(false);
  const inputSize = 12;

  const toggleShowPassword = (): void => {
    setShowPassword(!showPassword);
  };

  return (
    <Container>
      <PasswordField
        type={showPassword ? 'text' : 'password'}
        value={value}
        readOnly
        size={inputSize}
      />
      <IconButton
        onClick={toggleShowPassword}
        icon={showPassword ? 'ViewOffIcon' : 'ViewIcon'}
        size="S"
      />
    </Container>
  );
}
